import '@vaadin/custom-field';

import { componentName, SamlGroupMappingsClass } from './SamlGroupMappingsClass';
import '../../descope-text-field';
import '../descope-mappings-field';
import './descope-saml-group-mappings-internal';

customElements.define(componentName, SamlGroupMappingsClass);

export { SamlGroupMappingsClass, componentName };
